import * as model from './inkTonerModels';

export default class MyPrintersCarousel {
	constructor(element) {
		if (!element) return;

		this.element = element;
		this.elementParent = element.closest('.shaded-row');

		this.init();
	}

	init() {
		initialiseCarousel(this.element, window.od.myPrinters.data);
		deviceDeleteListener(this.element);
	}
}

// Variables
const bemBlockRow = 'my-printers-carousel';
const bemBlockTile = 'mini-product-tile';
const owlConfig = {
	loop: false,
	dots: false,
	autoWidth: true,
	responsiveClass: true,
	mouseDrag: false,
	responsive: {
		0: {
			nav: false,
		},
		1032: {
			nav: true,
		},
	},
};

// Private Functions
function initialiseCarousel(element, carouselArr) {
	setCarouselHTML(element, carouselArr);
	initOwlCarousel(element);
}

function setCarouselHTML(element, carouselArr) {
	const carouselMarkup = buildCarouselMarkup(element, carouselArr);
	element.innerHTML = carouselMarkup;
}

function buildCarouselMarkup(element, carouselData) {
	let carouselMarkup = '';

	element.classList.add('owl-carousel');
	carouselData.forEach(val => {
		carouselMarkup += buildCarouselItemMarkup(
			val.productCode,
			val.description,
			val.deviceId,
			val.deviceUrl,
		);
	});
	return carouselMarkup;
}

export function buildCarouselItemMarkup(
	productCode,
	description,
	deviceId,
	deviceUrl,
) {
	const { inkTonerURL } = window.od.searchOptionsInkToner;
	const hrefUrl = deviceUrl || `device?q=::deviceId:${deviceId}`;

	if (inkTonerURL) {
		return `
		<li class="${bemBlockRow}__item">
			<div class="${bemBlockTile}">
				<a class="${bemBlockTile}__link" href="${inkTonerURL}/${hrefUrl}">
					${imageMarkup(productCode)}
					<p class="${bemBlockTile}__title">${description}</p>
				</a>
				<button class="mini-product-tile__delete" data-control="delete" data-product-id="${deviceId}"><span class="sr-only">Close</span></button>
			</div>
		</li>
	`;
	}
	return console.error('const inkTonerURL returning no value'); // eslint-disable-line no-console
}
function imageMarkup(productCode) {
	if (productCode)
		return `<img class="${bemBlockTile}__img img-responsive" src="${window.CDN_CONFIG.rootUrl}/image/odeu13/${productCode}?wid=100&amp;hei=100&amp;fmt=png-alpha">`;
	return `<div class="${bemBlockTile}__device-placeholder"></div>`;
}

function deviceDeleteListener(element) {
	return element.addEventListener('click', e => {
		if (e.target.dataset.control === 'delete') {
			e.preventDefault();
			const deviceId = e.target.dataset.productId;
			element.classList.add('is-loading');
			removeDevice(element, deviceId);
		}
	});
}

function removeDevice(element, deviceId) {
	return model.deleteSelectedPrinter(deviceId).then(data => {
		const carouselArr = data.data;
		if (carouselArr.length > 0) {
			loadNewDevices(element, carouselArr);
		} else {
			removeContainer(element);
		}
	});
}

function loadNewDevices(element, carouselArr) {
	destroyCarousel(element);
	initialiseCarousel(element, carouselArr);
	element.classList.remove('is-loading');
}

function destroyCarousel(element) {
	return window.od.carousel.destroy(element);
}

function initOwlCarousel(element) {
	return window.od.carousel(element, owlConfig);
}

function removeContainer(element) {
	const parentElement = element.closest('.shaded-row');
	return parentElement.classList.add('is-hidden');
}
